const endpoints = [
  {
    type: "TEST",
    location: "salesportal-test.elk-studios.com",
    locationSchema: "https://",
    host: "https://papi-test.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-test.contentmedia.eu/1.0/game/",
    papiKey:
      "@C9B4A58B7E314dfsafda56AB3CF8A2C7D2A5fdasfdasfas1731EB03fdsafasfsdafasf5B43fds747F1A9C949901CD0C67B"
  },
  {
    type: "DEMO",
    location: "nitropolis.elk-studios.com",
    locationSchema: "https://",
    host: "https://papi-demo.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-demo.contentmedia.eu/1.0/game/",
    papiKey:
      "@OSJFQGVHZBFLOMCZQPYMDCRVZOYQIYTSXWOSNJSLBYYUODPZNYECAAHPVYMWFITFMJHXNWDCJRKQQNQHQAZVLPUOSNKZPOGZ"
  },
  {
    type: "DEMO",
    location: "salesportal.elk-studios.com",
    locationSchema: "https://",
    host: "https://papi-demo.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-demo.contentmedia.eu/1.0/game/",
    papiKey:
      "@OSJFQGVHZBFLOMCZQPYMDCRVZOYQIYTSXWOSNJSLBYYUODPZNYECAAHPVYMWFITFMJHXNWDCJRKQQNQHQAZVLPUOSNKZPOGZ"
  },
  {
    type: "DEMO",
    location: "maple.elk-studios.com",
    locationSchema: "https://",
    host: "https://papi-demo.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-demo.contentmedia.eu/1.0/game/",
    papiKey:
      "@OSJFQGVHZBFLOMCZQPYMDCRVZOYQIYTSXWOSNJSLBYYUODPZNYECAAHPVYMWFITFMJHXNWDCJRKQQNQHQAZVLPUOSNKZPOGZ"
  },
  {
    type: "DEMO",
    location: "ash.elk-studios.com",
    locationSchema: "https://",
    host: "https://papi-demo.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-demo.contentmedia.eu/1.0/game/",
    papiKey:
      "@OSJFQGVHZBFLOMCZQPYMDCRVZOYQIYTSXWOSNJSLBYYUODPZNYECAAHPVYMWFITFMJHXNWDCJRKQQNQHQAZVLPUOSNKZPOGZ"
  },
  {
    type: "DEMO",
    location: "oak.elk-studios.com",
    locationSchema: "https://",
    host: "https://papi-demo.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-demo.contentmedia.eu/1.0/game/",
    papiKey:
      "@OSJFQGVHZBFLOMCZQPYMDCRVZOYQIYTSXWOSNJSLBYYUODPZNYECAAHPVYMWFITFMJHXNWDCJRKQQNQHQAZVLPUOSNKZPOGZ"
  },
  {
    type: "DEMO",
    location: "pine.elk-studios.com",
    locationSchema: "https://",
    host: "https://papi-demo.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-demo.contentmedia.eu/1.0/game/",
    papiKey:
      "@OSJFQGVHZBFLOMCZQPYMDCRVZOYQIYTSXWOSNJSLBYYUODPZNYECAAHPVYMWFITFMJHXNWDCJRKQQNQHQAZVLPUOSNKZPOGZ"
  },
  {
    type: "DEMO",
    location: "localhost:10000",
    locationSchema: "http://",
    host: "https://papi-demo.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-demo.contentmedia.eu/1.0/game/",
    papiKey:
      "@OSJFQGVHZBFLOMCZQPYMDCRVZOYQIYTSXWOSNJSLBYYUODPZNYECAAHPVYMWFITFMJHXNWDCJRKQQNQHQAZVLPUOSNKZPOGZ"
  },
  {
    type: "DEV",
    location: "localhost:3000",
    locationSchema: "http://",
    host: "https://papi-test.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-test.contentmedia.eu/1.0/game/",
    papiKey:
      "@C9B4A58B7E314dfsafda56AB3CF8A2C7D2A5fdasfdasfas1731EB03fdsafasfsdafasf5B43fds747F1A9C949901CD0C67B"
  },
  {
    type: "Dev-api",
    location: "localhost:33006",
    locationSchema: "http://",
    host: "http://localhost:33007/partnerapi/2.0",
    gamelauncher: "https://gamelauncher-test.contentmedia.eu/1.0/game/"
  },
  {
    type: "Dev-prod",
    location: "localhost:5000",
    locationSchema: "http://",
    host: "https://papi-test.contentmedia.eu/2.0",
    gamelauncher: "https://gamelauncher-test.contentmedia.eu/1.0/game/"
  }
];
export const REACT_APP_ENV = (() => {
  for (let i = 0; i < endpoints.length; i++) {
    if (endpoints[i].location === window.location.host) {
      return endpoints[i].type;
    }
  }
  return "DEV";
})();

export const BASE_URL = (() => {
  for (let i = 0; i < endpoints.length; i++) {
    if (endpoints[i].location === window.location.host) {
      return endpoints[i].host;
    }
  }
  return "https://papi-test.contentmedia.eu/2.0";
})();

export const PAPIKEY = (() => {
  for (let i = 0; i < endpoints.length; i++) {
    if (endpoints[i].location === window.location.host) {
      return endpoints[i].papiKey;
    }
  }
  return "@C9B4A58B7E314dfsafda56AB3CF8A2C7D2A5fdasfdasfas1731EB03fdsafasfsdafasf5B43fds747F1A9C949901CD0C67B\r\n";
})();

export const GAME_LAUNCHER = (() => {
  for (let i = 0; i < endpoints.length; i++) {
    if (endpoints[i].location === window.location.host) {
      return endpoints[i].gamelauncher;
    }
  }
  return "https://gamelauncher-test.contentmedia.eu/1.0/game/";
})();
export function endpoint() {
  for (let i = 0; i < endpoints.length; i++) {
    if (endpoints[i].location === window.location.host) {
      return endpoints[i];
    }
  }
  return endpoints[3];
}

export const staticGameId = null;
//export const staticGameId = 10053;
